import { Content } from '@prismicio/client';
import { PrismicNextImage } from '@prismicio/next';
import { Simplify } from '../../../../prismicio-types';
import styles from './BeyondImageContent.module.scss';
import { WhiteCheckmarkIcon } from '@/assets/icons/PartnerPagesIcons';

interface Props {
  data: Simplify<Content.PartnerHeroSliceBeyondPrimary>;
}

const BeyondImageContent = ({ data }: Props) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.leftBlock}>
        <div className={styles.infoLabel}>{data.infolabel}</div>
        <PrismicNextImage
          field={data.secondpersonimg}
          className={styles.secondPersonImg}
        />
        <PrismicNextImage field={data.partnerlogo} className={styles.logo} />
      </div>
      <div className={styles.rightBlock}>
        <div className={styles.infoCard}>
          <div className={styles.infoCardHead}>
            <span className={styles.infoCardTitle}>{data.infotitle}</span>
            <div className={styles.iconWrapper}>
              <WhiteCheckmarkIcon className={styles.icon} />
            </div>
          </div>
          <p className={styles.infoCardValue}>{data.infovalue}</p>
        </div>
        <PrismicNextImage field={data.personimg} className={styles.personImg} />
      </div>
    </div>
  );
};

export default BeyondImageContent;
